import script from "./MiNTNewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsList.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsList.vue?vue&type=style&index=0&id=127064c8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127064c8"]])

export default __exports__